export default __webpack_public_path__ + "static/media/ic_file_eadd.cc6b8597.svg";